import { IRouteConfig, IRoutingConfig } from '../../_shared/models/models-index';

export class RoutingConfig implements IRoutingConfig {

  allRoles = ["System Administrator", "Corporate", "Region Manager", "Area Manager", "District Manager", "Dealer", "Dealer Group", "Agency", "System Analyst"];
  allRolesExceptAgency = ["System Administrator", "Corporate", "Region Manager", "Area Manager", "District Manager", "Dealer", "Dealer Group", "System Analyst"];

  public routes: IRouteConfig[] = [
    {
      id: 'logout',
      category: 'logout',
      iconClass: null,
      displayName: null,
      displayInNav: false,
      defaultRoute: '/logout',
      roles: undefined,
      children: [],
      routeData: {
        redirectOnLogout: true,
      }
    },
    //{
    //  id: 'leads',
    //  category: 'leads',
    //  default: true,
    //  defaultRoute: '/leads/overview',
    //  displayName: 'Leads',
    //  displayInNav: true,
    //  iconClass: 'fa fa-users',
    //  roles: undefined,
    //  children: [
    //    {
    //      parent: '/leads',
    //      route: 'overview',
    //      displayName: 'Overview',
    //      iconClass: 'fa fa-users',
    //      pdfEnabled: false,
    //      roles: undefined,
    //      breadcrumbHelpEnabled: true
    //    },
    //    {
    //      parent: '/leads',
    //      route: 'summary',
    //      displayName: 'Summary',
    //      iconClass: 'fa fa-list',
    //      roles: undefined,
    //      breadcrumbHelpEnabled: true
    //    },
    //    {
    //      parent: '/leads',
    //      route: 'sourcePerformance',
    //      displayName: 'Source',
    //      iconClass: 'fa fa-list',
    //      roles: undefined
    //    },
    //    {
    //      parent: '/leads',
    //      route: 'vehiclePerformance',
    //      displayName: 'Vehicle',
    //      iconClass: 'fa fa-car',
    //      roles: undefined,
    //      breadcrumbHelpEnabled: true
    //    },
    //    {
    //      parent: '/leads',
    //      route: 'transactions',
    //      displayName: 'Transactions',
    //      iconClass: 'fa fa-exchange',
    //      roles: undefined,
    //      breadcrumbHelpEnabled: true
    //    },
    //    {
    //      parent: '/leads',
    //      route: 'process-performance',
    //      displayName: 'Process Performance',
    //      iconClass: 'fa fa-exchange',
    //      roles: undefined,
    //      breadcrumbHelpEnabled: true
    //    },
    //  ]
    //},
    {
      id: 'website',
      category: 'website',
      defaultRoute: '/website/website-overview',
      displayName: 'Website',
      displayInNav: true,
      default: true,
      iconClass: 'fa fa-globe',
      roles: undefined,
      children: [
        {
          parent: '/website',
          route: 'website-overview',
          displayName: 'Overview',
          pdfEnabled: false,
          breadcrumbHelpEnabled: true,
          iconClass: 'fa fa-users',
          roles: undefined
        }]
    },
    {
      id: 'digAd',
      category: 'digAd',
      default: true,
      defaultRoute: '/digAd/dashboard',
      displayName: 'Digital Advertising',
      displayInNav: true,
      iconClass: 'fa fa-desktop',
      roles: null,
      children: [
        {
          parent: '/digAd',
          route: 'dashboard',
          displayName: 'Overview',
          pdfEnabled: false,
          breadcrumbHelpEnabled: true,
          iconClass: 'fa fa-users',
          roles: undefined
        }
      ]
    },
    {
      id: 'management',
      category: 'management',
      defaultRoute: '/management/users',
      displayName: 'Management',
      displayInNav: true,
      iconClass: 'fa fa-cog',
      roles: ['System Administrator', "System Analyst"],
      children: [
        {
          parent: '/management',
          route: 'content',
          displayName: 'Content',
          iconClass: 'fa fa-code',
          roles: ['System Administrator', "System Analyst"]
        },
        {
          parent: '/management',
          route: 'report-views-configuration',
          displayName: 'Report Views',
          iconClass: 'fa fa-code',
          roles: ['System Administrator', "System Analyst"],
          children:
          [
            {
              id: 'report-views-configuration/create',
              parent: 'report-views-configuration',
              route: 'create',
              displayName: 'Create Report View',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'report-views-configuration/create',
              parent: 'report-views-configuration',
              route: 'create/:id',
              displayName: 'Create Report View',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'report-views-configuration/update',
              parent: 'report-views-configuration',
              route: 'update/:id',
              displayName: 'Edit Report View',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'report-views-configuration/import',
              parent: 'report-views-configuration',
              route: 'import',
              displayName: 'Import Report Views',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'report-views-configuration/view',
              parent: 'report-views-configuration',
              route: 'view/:id',
              displayName: 'View Report',
              iconClass: 'fa fa-code',
              roles: ['System Administrator', 'System Analyst'],
            },
          ]
        }, {
          parent: '/management',
          route: 'data-sets-configuration',
          displayName: 'Data Sets',
          iconClass: 'fa fa-code',
          roles: ['System Administrator', "System Analyst"],
          children:
          [
            {
              id: 'data-sets-configuration/create',
              parent: 'data-sets-configuration',
              route: 'create',
              displayName: 'Create Data Set',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'data-sets-configuration/create',
              parent: 'data-sets-configuration',
              route: 'create/:id',
              displayName: 'Create Data Set',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'data-sets-configuration/create',
              parent: 'data-sets-configuration',
              route: 'create/project/:queryConfigId',
              displayName: 'Create Data Set',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'data-sets-configuration/update',
              parent: 'data-sets-configuration',
              route: 'update/:id',
              displayName: 'Edit Data Set',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'data-sets-configuration/import',
              parent: 'data-sets-configuration',
              route: 'import',
              displayName: 'Import Data Sets',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'data-sets-configuration/view',
              parent: 'data-sets-configuration',
              route: 'view/:id',
              displayName: 'View Data Set',
              iconClass: 'fa fa-code',
              roles: ['System Administrator', 'System Analyst'],
            },
          ]
        }, {
          parent: '/management',
          route: 'query-configuration',
          displayName: 'Queries',
          iconClass: 'fa fa-code',
          roles: ['System Administrator', "System Analyst"],
          children:
          [
            {
              id: 'query-configuration/create',
              parent: 'query-configuration',
              route: 'create',
              displayName: 'Create Query',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'query-configuration/create',
              parent: 'query-configuration',
              route: 'create/:id',
              displayName: 'Create Query',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'query-configuration/update',
              parent: 'query-configuration',
              route: 'update/:id',
              displayName: 'Edit Query',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'query-configuration/test',
              parent: 'query-configuration',
              route: 'test/:id',
              displayName: 'Test Query',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'query-configuration/import',
              parent: 'query-configuration',
              route: 'import',
              displayName: 'Import Queries',
              iconClass: 'fa fa-code',
              roles: ['System Administrator'],
            },
            {
              id: 'query-configuration/view',
              parent: 'query-configuration',
              route: 'view/:id',
              displayName: 'View Query',
              iconClass: 'fa fa-code',
              roles: ['System Administrator', 'System Analyst'],
            },
          ]
        },
        {
          parent: '/management',
          route: 'resource-string',
          displayName: 'Resource Strings',
          iconClass: 'fa fa-code',
          roles: ['System Administrator', "System Analyst"],
          children: [
            {
              id: 'resource-string/create',
              parent: 'resource-string',
              route: 'create',
              displayName: 'Create Resource String',
              iconClass: 'fa fa-code',
              roles: ['System Administrator', "System Analyst"],
            },
            {
              id: 'resource-string/update',
              parent: 'resource-string',
              route: 'update/:id',
              displayName: 'Edit Resource String',
              iconClass: 'fa fa-code',
              roles: ['System Administrator', "System Analyst"],
            }
          ]
        },
        {
          parent: '/management',
          route: 'users',
          displayName: 'Users',
          iconClass: 'fa fa-users',
          roles: ['System Administrator', "System Analyst"]
          },
          {
              parent: '/management',
              route: 'settings',
              displayName: 'Settings',
              iconClass: 'fa fa-code',
              roles: ['System Administrator']
          }
      ]
    }
  ];
}
